import $ from "jquery";
// web/mobile/appで定義
const request = window.__forcia__.request;

function spookCommand(store, command, data, key) {
	var d = new $.Deferred;
	request(command, {
		data: data,
		callback: (data) => {
			var o = {};
			o[key || command] = data;
			store.state.set(o);
			d.resolve();
		}
	});
	return d.promise();
}

//FIXME: requestのexport
// もともとexportするのはspookCommandだけの想定だったが、
// callbackやbeforesendで処理を追加する必要があったため直接requestをexportしている
// spookCommandだけでシンプル＆柔軟にかければrequestはexportせずまとめた方がよい
export {request};
export default spookCommand;



// WEBPACK FOOTER //
// ./web/WEB-INF/js/client/modules/request.js